var _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigging(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.611,
    cy: 24.117,
    r: 7.159
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 68.5c-5.454-.355-7.644 1.765-7.996 4.65L49 62.428l-4.298-16.539c-.271-1.041-3.391-9.771-3.74-10.212l-6.829-8.639c-.54-.683-1.148-.876-3.25-.831 0 0-11.7 0-12.478.009-.748-.016-1.757 1.139-2.399 2.153l-8.63 12.514c-.924 1.339-.455 3.266 1.047 4.301l.566.391c1.502 1.036 3.469.79 4.393-.55l.38-.551 5.891 3.609-.595.863c-.731 1.188-.542 4.922-.56 5.42l.014 13.812-9.832 14.26a3.304 3.304 0 0 0 .844 4.596l.567.391a3.303 3.303 0 0 0 4.596-.845l9.477-13.739c.711-.984 1.608-2.387 1.607-3.609l.028-11.813 11.166 7.053v20.234a3.306 3.306 0 0 0 3.305 3.305h.688a3.305 3.305 0 0 0 3.304-3.305V67.92a3.281 3.281 0 0 0 2.076.143l.667-.174a3.288 3.288 0 0 0 2.126-1.747L64.5 75.557a9.535 9.535 0 0 0-1.162 1.764 27.255 27.255 0 0 0-4.563.82c-6.594 1.764-11.623 6.119-12.65 9.866h46.913V62.299C84.375 57.104 74.375 63.5 74.5 68.5zM36.277 44.403l3.252 12.224-8.159-4.998 4.907-7.226zM21.331 33.499l8.611.004-8.522 12.031-5.897-3.612 5.808-8.423z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigging);
export default __webpack_public_path__ + "static/media/digging.6ccef9922568f39926311f85bfa283b3.svg";
export { ForwardRef as ReactComponent };